







































































import { Component, Vue, Prop } from 'vue-property-decorator';

import {
  ResponseCodeEnum,
  DataTableRequest,
  TireStoringContract,
  EnumObject,
  DataBus,
} from '@/models';

import { tireStoringContractService, toastService } from '@/services';

import { ContractDataTableSetting, FieldEnum, ActionEnum } from '@/components/shared';
import DataTable from '@/components/shared/table/DataTable.vue';
import PickUpCalendar from '@/components/pickup/PickupCalendar.vue';
import _ from 'lodash';

@Component({
  components: {
    DataTable,
    PickUpCalendar,
  },
})
export default class SearchContractAndPickup extends Vue {
  @Prop() public date!: string;
  @Prop() public totalPickup!: number;
  private contractDate: string = '';
  private searchText: string = '';
  private total: number = 0;
  private showModal: boolean = false;
  private isChooseDatePickup: boolean = false;
  private autoFill: boolean = false;
  private showPickupModal: boolean = false;
  private showDate: string = '';
  private tableFields = [
    {
      key: 'slipNo',
      label: 'view.search_tire_contract.label.contract_number',
      type: FieldEnum.FIELD_TEXT,
      sortable: false,
    },
    {
      key: 'customer.name',
      label: 'view.search_tire_contract.label.fullname',
      type: FieldEnum.FIELD_TEXT,
      sortable: false,
    },
    {
      key: 'storingDate',
      label: 'view.pick-up.pick-up-calendar.label.storing_date',
      type: FieldEnum.FIELD_CUSTOM,
      sortable: false,
      htmlFunction: (item: TireStoringContract) => this.formatterStartDate(item.storingDate)

    },
    {
      key: 'pickupDate',
      label: 'view.pick-up.pick-up-calendar.label.pickup-request',
      type: FieldEnum.FIELD_BUTTON_TEXT,
      sortable: false,
      merge: true,
      buttons: [
        {
          'key': 'pickupDate',
          'type': ActionEnum.ACTION_CUSTOM,
          'iconClass': '',
          'text': 'view.pick-up.pick-up-calendar.label.pick_of_date',
          'method': (item: any) => this.settingPickupDate(item),
        },
      ],
    }
  ];
  private getItems: Function = new Function();
  private tableSetting: ContractDataTableSetting = new ContractDataTableSetting();
  private selectedItem: TireStoringContract = new TireStoringContract();

  private created() {
    this.$moment.tz.setDefault('UTC');
    this.autoFill = false;
    this.contractDate = this.$moment(this.date).format('ddd Do MMMM YYYY');
    this.total = this.totalPickup ? this.totalPickup : 0;
    this.getItems = ((request: DataTableRequest) => {
      return tireStoringContractService
        .getPickupContractByContractEndDate(request, this.autoFill)
        .then((res) => {
          if (res.data.items && res.data.totalRows) {
            this.tableSetting.totalRows = res.data.totalRows;
            this.total = res.data.totalRows;
            this.tableSetting.contracts = res.data.items || [];
            return res.data.items || [];
          }
        });
    });
    this.tableSetting = ContractDataTableSetting.init(
      'slipNo',
      'desc',
      this.tableFields,
      this.getItems,
      false,
      false,
    );
    this.tableSetting.filter = this.date ? this.$moment(this.date).format('YYYY-MM-DD'): '';
  }

  private search() {
    this.tableSetting.filter = this.searchText;
  }

  private async autoSetting() {
    if (this.tableSetting.totalRows === 0) {
       toastService.errorMessage('view.delivery_request.msg.record_empty');
    } else {
      const contractIds = this.tableSetting.contracts
        .map((contract) => contract.id)
        .filter((contractId) => contractId !== undefined);
      await tireStoringContractService.autoSetPickup(contractIds)
        .then((res) => {
          if(res.data.code === ResponseCodeEnum.CODE_SUCCESS) {
            (this.$refs.dataTable as any).refreshTable();
          }
        }).catch((err) => {
          this.tableSetting.contracts = [];
        });
    }
  }

    private openModalPickup() {
    const contracts = this.tableSetting.contracts
        .filter((contract) => contract.pickupDate !== null);
    let lstDate: string[] = [];
    _.forEach(contracts, (item: any) => {
      let pickupDate = this.$moment(item.pickupDate).format('MM/DD(dd)');
      lstDate.push(pickupDate);
    })

    lstDate = [...new Set(lstDate)];
    this.showDate = `${this.$t('dialog.dateSelect').toString()} ${lstDate.toString()}`
    this.showPickupModal = true;
  }

  private pickup() {
    if (this.tableSetting.contracts.length === 0) {
      this.showModal = true;
    } else {
      const contracts = this.tableSetting.contracts
        .filter((contract) => contract.pickupDate !== null);
      if (contracts.length === 0) {
        this.showModal = true;
      } else {
        tireStoringContractService.pickupContract(contracts)
        .then((res) => {
          if (res.data.code === ResponseCodeEnum.CODE_BUSINESS) {
            toastService.errorMessage(res.data.data);
          }
          if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
            if(res.data.data.length === 0) {
              toastService.successMessage('view.delivery_request.msg.request_delivery_success');
              this.tableSetting.contracts = [];
            } else {
              res.data.data.forEach((element: any) => {
                toastService.errorMessage(this.$t('view.pick-up.pick-up-calendar.msg.can_not_pickup') + element);
              });
            }
            (this.$refs.dataTable as any).refreshTable();
          }
          if(res.data.code === ResponseCodeEnum.CODE_BAD_REQUEST && res.data.data) {
            let message = res.data.data.map((a: any) => 
              this.$t('view.tire_register.message.delivery_exceeded').toString().replace('{agency_name}', a.name).replace('{limit}', a.limitDeliveryValue ? a.limitDeliveryValue: 0) + '</br>'
            )       
            .join('');
            toastService.errorMessage(message);
          }
        });
      }
    }
  }

  private settingPickupDate(item: TireStoringContract) {
    this.isChooseDatePickup = true;
    if (item.id) {
      this.selectedItem = item;
    }
  }

  private changeDatePickup(date: Date) {
    this.isChooseDatePickup = false;
    this.selectedItem.pickupDate = this.$moment(date, 'DD/MM/YYYY').toDate();
    if (this.selectedItem.id) {
      tireStoringContractService.setPickupDate(this.selectedItem.id, this.$moment(date).format('YYYY-MM-DD'))
          .then((res) => {
            if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
              toastService.successMessage('view.pick-up.pick-up-calendar.msg.pickup_date_selected');
            }
            // In case no more slot available, reload calendar
            if (res.data.code === ResponseCodeEnum.CODE_BUSINESS) {
              toastService.errorMessage('view.pick-up.pick-up-calendar.msg.pickup_date_can_not_select');
            }
          });
    }
    let itemIndex = -1;
    this.tableSetting.contracts.forEach((element) => {
      if (this.selectedItem === element) {
        itemIndex = this.tableSetting.contracts.indexOf(element);
        if (itemIndex >= 0) {
          element = this.selectedItem;
        }
        return;
      }
    });
    if (itemIndex < 0) {
      this.tableSetting.contracts.push(this.selectedItem);
    }
  }

  private closeCalendar() {
    this.isChooseDatePickup = false;
  }


  private getDayOfWeek(value: number) {
    switch (value) {
      case 0: return this.$t("common.day_of_week.sunday").toString();
      case 1: return this.$t("common.day_of_week.monday").toString();
      case 2: return this.$t("common.day_of_week.tuesday").toString();
      case 3: return this.$t("common.day_of_week.wednesday").toString();
      case 4: return this.$t("common.day_of_week.thursday").toString();
      case 5: return this.$t("common.day_of_week.friday").toString();
      case 6: return this.$t("common.day_of_week.saturday").toString();
    }
  }

  private formatterStartDate(storingDate?: Date): any {
    if (!storingDate) {
      return "";
    }
    const formatterDate = this.$moment(storingDate).format('YYYY-MM-DD') + " ("+ this.getDayOfWeek(new Date(storingDate).getUTCDay()) + ")";
    return formatterDate;
  }

}
